import { ShowPageLayout } from 'framework/ui/layout';
import { Show } from 'framework/show';
import { useProjectService } from 'domain/shared/project';
import { DataGridLayout, List, RelationListLayout } from 'framework/list';
import { EnumField, FormattedDateField } from 'framework/ui/field';
import useProjectWeeklyReportsService, {
  ProjectWeeklyReportStatusLabels,
} from 'domain/projects/project/weeklyreports/ProjectWeeklyReportService';
import { useParams } from 'react-router-dom';
import ProjectEntityHeader from 'domain/projects/project/shared/ProjectEntityHeader';
import ViewProjectPageMenu from 'domain/projects/project/Show/ViewProjectPageMenu';
import ProjectReportsBreadcrumbs from 'domain/projects/project/weeklyreports/shared/ProjectWeeklyReportsBreadcrumbs';
import ProjectReportLinkField from 'domain/projects/project/weeklyreports/shared/field/ProjectWeeklyReportLinkField';
import { DATE_FORMAT } from 'framework/utils';
import { ArtifactStorageOneFileLink } from 'domain/shared/artifactStorage';

const ProjectWeeklyReportList = () => {
  const { id: projectId } = useParams<Dictionary<string>>();
  const { search } = useProjectWeeklyReportsService();
  const { getById } = useProjectService();

  return (
    <Show getDataMethod={() => getById(projectId!)}>
      <ShowPageLayout
        entityHeader={<ProjectEntityHeader />}
        menu={<ViewProjectPageMenu />}
        breadcrumbs={<ProjectReportsBreadcrumbs />}
      >
        <List getDataMethod={search}>
          <RelationListLayout header="Weekly Report">
            <DataGridLayout isSmallTable showTotal={false}>
              <ProjectReportLinkField
                source="id"
                sourceDateFrom="from"
                sourceDateTo="to"
                label="Weekly cycle period"
                width="40%"
              />
              <FormattedDateField source="updatedAt" format={DATE_FORMAT.FULL_DATE} label="Modification date" />
              <EnumField label="Status" source="status" options={ProjectWeeklyReportStatusLabels} />
              <ArtifactStorageOneFileLink label="Report" source="report.id" linkText="View report" width="150px" />
            </DataGridLayout>
          </RelationListLayout>
        </List>
      </ShowPageLayout>
    </Show>
  );
};

export default ProjectWeeklyReportList;
